import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Dashboard from "./components/Dashboard";
import Home from "./components/Home";
import Login from "./components/Login";
import Onboarding from "./components/Onboarding";
import Otp from "./components/Otp";
import SecurityPin from "./components/SecurityPin";
import SignUp from "./components/Signup";
import ProtectedRoute from "./components/ProtectedRoute";
import TransferBankToWallet from "./components/Transfers/BankToWallet";
import TransferOtherWallet from "./components/Transfers/OtherWallet";
import TransferWalletToBank from "./components/Transfers/WalletToBank";
import PaymentAirtime from "./components/Payments/Airtime";
import Settings from "./components/Settings";
import PaymentElectricity from "./components/Payments/Electricity";
import ForgotPassword from "./components/ForgotPin";
import BankTransfer from "./components/FundWallet/BankTransfer";
import CashDeposit from "./components/FundWallet/CashDeposit";
import DataSubscription from "./components/Payments/Data";
import BvnVerificationStatus from "./components/BvnVerificationStatus";
import StartBvnVerification from "./components/StartBvnVerification";
import UserRegistration from "./components/Registration";
import VerifyDetails from "./components/VerifyDetails";
import StartNINVerification from "./components/StartNINVerification";
import FAQ from "./components/FAQ";
import ReferralsTermsAndConditions from "./components/T&C/ReferralsTerms&Conditions";
import AccountTermsAndConditions from "./components/T&C/AccountTerms&Conditions";
import CardsTermsAndConditions from "./components/T&C/CardsTerms&Conditions";
import BlackFridayTermsAndConditions from "./components/T&C/BlackFridayTerms&Conditions";
import { DownloadRedirect } from "./components/DownloadRedirect";
import SavingsTermsAndConditions from "./components/T&C/SavingsTerms&Conditions";
import InsuranceTermsAndConditions from "./components/T&C/Insurancetermsandconditions";

function App() {
  return (
    <Router>
      <Switch>
        <ProtectedRoute exact path="/dashboard" component={Dashboard} />
        <ProtectedRoute
          exact
          path="/dashboard/fund-wallet/cash-deposit"
          component={CashDeposit}
        />
        <ProtectedRoute
          exact
          path="/dashboard/fund-wallet/bank-transfer"
          component={BankTransfer}
        />
        <ProtectedRoute
          exact
          path="/dashboard/transfers/other-wallet"
          component={TransferOtherWallet}
        />
        <ProtectedRoute
          exact
          path="/dashboard/transfers/bank-to-wallet"
          component={TransferBankToWallet}
        />
        <ProtectedRoute
          exact
          path="/dashboard/transfers/wallet-to-bank"
          component={TransferWalletToBank}
        />
        <ProtectedRoute
          exact
          path="/dashboard/payments/airtime"
          component={PaymentAirtime}
        />
        <ProtectedRoute
          exact
          path="/dashboard/payments/electricity"
          component={PaymentElectricity}
        />
        <ProtectedRoute
          exact
          path="/dashboard/payments/data"
          component={DataSubscription}
        />
        <ProtectedRoute exact path="/settings" component={Settings} />
        <ProtectedRoute
          exact
          path="/settings/delete-account"
          component={Settings}
        />
        <Route exact path="/login">
          <Login />
        </Route>
        <Route exact path="/signup">
          <SignUp />
        </Route>
        <Route exact path="/otp">
          <Otp />
        </Route>
        <Route path="/register">
          <UserRegistration />
        </Route>
        <Route path="/verify">
          <VerifyDetails />
        </Route>
        <Route path="/onboarding">
          <Onboarding />
        </Route>
        <Route path="/security-pin">
          <SecurityPin />
        </Route>
        <Route exact path="/forgot-pin">
          <ForgotPassword />
        </Route>
        <Route path="/bvn-verification-status">
          <BvnVerificationStatus />
        </Route>
        <Route path="/bvn-verification-start">
          <StartBvnVerification />
        </Route>
        <Route path="/nin-verification-start">
          <StartNINVerification />
        </Route>
        <Route path="/faq">
          <FAQ />
        </Route>
        <Route path="/terms-and-conditions/account">
          <AccountTermsAndConditions />
        </Route>
        <Route path="/terms-and-conditions/referrals">
          <ReferralsTermsAndConditions />
        </Route>
        <Route path="/terms-and-conditions/cards">
          <CardsTermsAndConditions />
        </Route>
        <Route path="/terms-and-conditions/black-friday">
          <BlackFridayTermsAndConditions />
        </Route>
        <Route path="/terms-and-conditions/savings">
          <SavingsTermsAndConditions />
        </Route>
        <Route path="/terms-and-conditions/insurance">
          <InsuranceTermsAndConditions />
        </Route>
        <Route path="/referral/:referral_code">
          <DownloadRedirect />
        </Route>
        <Route path="/">
          <Home />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;